import React from 'react';
import Layout from '../../components/Layout';
import Reviews from './Reviews';

const title = 'BestHand Reviews — Customer Stories';
const description =
  'See why customers choose BestHand for cleaning, plumbing, electrical, moving and more — vetted local pros, upfront pricing and secure in-app payments.';

function action() {
  return {
    title,
    description,
    component: (
      <Layout>
        <Reviews />
      </Layout>
    ),
  };
}

export default action;
